import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useAsteriskDialler } from '~providers/AsteriskDiallerProvider';

const OfferedCallPanel = () => {
  const { state: dialler, socketRef } = useAsteriskDialler();
  const call = dialler.offeredCall;

  if (!call) return null;

  const agentUsernames = Object.values(call.agentControls)
    .map((ac) => ac.username)
    .join(', ');

  const infoRows = [
    { label: 'Lead ID', value: String(call.lead.leadId) },
    { label: 'External ID', value: call.lead.externalId },
    { label: 'Timezone', value: call.lead.timezone },
    { label: 'Endpoint', value: call.lead.endpoints[0] ?? '' },
    { label: 'Required Skills', value: call.lead.requiredSkills },
    ...(call.lead.callbackNotes !== null ? [{ label: 'Callback Notes', value: call.lead.callbackNotes }] : []),
  ];

  // Dynamic lead attributes (handleOfferedConference in App.svelte)
  const leadAttributes = Object.entries(call.lead.attributes).map(([k, v]) => ({
    label: k.replace(/_/g, ' '),
    value: v,
  }));

  // Endpoint attributes (App.svelte:635-640)
  const endpointAttributeRows = Object.entries(
    call.lead.endpointAttributes[call.lead.endpoints[0]]?.attributes ?? {},
  ).map(([k, v]) => ({
    label: k.replace(/_/g, ' '),
    value: v,
  }));

  return (
    <Card elevation={1} sx={{ mt: 2 }}>
      <Box sx={{ textAlign: 'center', p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <Typography variant='h5' fontWeight={700}>
          {agentUsernames}
        </Typography>
      </Box>

      <CardContent>
        {[...infoRows, ...leadAttributes, ...endpointAttributeRows].map(({ label, value }) => (
          <Box key={label} display='flex' py={0.5}>
            <Typography variant='body2' fontWeight={600} sx={{ minWidth: 150, textTransform: 'capitalize' }}>
              {label}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {value}
            </Typography>
          </Box>
        ))}

        <Box mt={3} display='flex' justifyContent='center' gap={2}>
          <Button
            variant='contained'
            color='error'
            onClick={() => socketRef.current?.rejectCall(call.id)}
            sx={{ textTransform: 'none' }}>
            Reject
          </Button>
          <Button
            variant='contained'
            color='success'
            onClick={() => socketRef.current?.acceptCall(call.id)}
            sx={{ textTransform: 'none' }}>
            Accept
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default OfferedCallPanel;
